import React from 'react';
import TypeQuickConverter from './components/TypeQuickConverter';
import './App.css';

function App() {
  return (
    <div className="App">
      <TypeQuickConverter />
    </div>
  );
}

export default App;